// Presentation only: never rewrite the HTML saved or sent by the composer.
export function syncEmailFrameTheme(frame) {
  const doc = frame?.contentDocument;
  if (!doc?.body) return;
  const styles = getComputedStyle(frame);
  const dark = document.documentElement.getAttribute('data-bun-theme') === 'dark';
  doc.documentElement.setAttribute('data-bun-theme', dark ? 'dark' : 'light');
  // Matching schemes allow the transparent iframe canvas to show the app surface.
  frame.style.colorScheme = dark ? 'dark' : 'light';
  doc.documentElement.style.colorScheme = dark ? 'dark' : 'light';
  ['text', 'blue'].forEach(token => {
    doc.documentElement.style.setProperty(`--bun-${token}`, styles.getPropertyValue(`--bun-${token}`));
  });
  doc.body.style.color = styles.color;
  doc.body.style.fontFamily = styles.fontFamily;
}

export const EMAIL_FRAME_THEME_CSS = `
  html, body { background: transparent; }
  html[data-bun-theme="dark"], html[data-bun-theme="dark"] body,
  html[data-bun-theme="dark"] body * {
    color: var(--bun-text) !important;
    background-color: transparent !important;
  }
  html[data-bun-theme="dark"] a[href], html[data-bun-theme="dark"] a[href] * {
    color: var(--bun-blue) !important;
  }
`;
